import React, { Component } from 'react'
import AppLoadable from 'components/AppLoadable'
import { NotFoundTitle, NotFoundWrapper, ActionLink, NotFoundParagraph } from './styles'

const PageWrapper = AppLoadable({
  loader: () => import('components/PageWrapper/PageWrapper')
})

class NotFound extends Component {
  render() {
    return (
      <PageWrapper ogTitle="Brownie Points | 404 page not found">
        <NotFoundWrapper>
          <NotFoundTitle>Page not found</NotFoundTitle>

          <NotFoundParagraph>
            You seem to have found yourself in the wrong place. Head back{' '}
            <ActionLink to={`/`}>home</ActionLink> and try again.
          </NotFoundParagraph>
        </NotFoundWrapper>
      </PageWrapper>
    )
  }
}

export default NotFound
